import React, {Component} from "react";
import {Layout, Cascader, Table, Divider, Modal, Form, Input, Pagination, Button, message} from 'antd';

import Header from '../../components/header'
import LeftAd from '../../components/leftAd'

import './skillAd.less'
import '../../assets/css/admin.less'
import {
    reqSkill,
    reqCategory,
    reqUpload,
    reqAddSkill,
    reqEditSkill,
    reqDeleteSkill, reqSkillDetail
} from "../../api";
import Radio from "antd/es/radio";
import '../../api/index';

const {Content} = Layout;
const {TextArea} = Input;

/**
 * 管理员技能训练路由组件
 */
class SkillAd extends Component {

    state = {
        skillList: [],
        category: [],
        total: 0,
        page: 1,
        size: 10,
        visible: false,
        ModalText: '',
        imgId: '',
        cid: 3,
        pid: 1,
        skill: {},
        deleteVisible: false,
        deleteId: '',
        deleteName: '',
        selectedRowKeys: [],
        cname:"望神色形态 / 望神"
    };

    deleteSkill = async (ids, e) => {
        e.persist();
        const result = await reqDeleteSkill(ids);
        if (result.code === '000000') {
            message.success("删除成功");
            this.getSkillList(3, 1, 10);
            this.handleCancel();
        }
    };

    editSkill = async (record, e) => {
        e.persist();
        const result = await reqSkillDetail(record.id);
        const data = result.data;
        let pid = 1;
        if (this.state.cid > 2 && this.state.cid < 8) {
            pid = 1
        } else {
            pid = 2
        }
        let options='';
        for (let i = 0; i < data.options.length; i++) {
            options += data.options[i].optionValue;
            if(i < data.options.length-1){
                options +="\n"
            }
        }
        if(data.imgs){
            this.state.imgId = data.imgs[0]
        }
        data.options = options;
        if(data.questions){
            data.answer = data.questions[0].correctAnswer;
        }
        this.setState({
            visible: true,
            ModalText: '编辑',
            skill: data,
            pid: pid
        });

    };

    showDeleteModal = (record, type) => {
        if (type === '删除') {
            this.setState({
                deleteId: record.id,
                deleteName: record.title,
                deleteVisible: true
            })
        } else {
            if (this.state.deleteId === '') {
                message.info("没有选中行");
            } else {
                this.setState({
                    deleteVisible: true
                })
            }
        }
    };

    onChange = (value) => {
        this.setState({
            cid: value[1],
            pid:value[0]
        })
    };

    handleSubmit = (event) => {
        //组织表单的默认行为
        event.preventDefault();
        //对所有表单字段进行校验
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                let optArr = values.option.split('\n');
                let question = {};
                question["correctAnswer"]= values.answer;
                question["question"]= "";
                question["questionType"]= values.questionType;
                let option = [];
                for (let i = 0; i < optArr.length; i++) {
                    option[i] = {"optionKey": String.fromCharCode(65 + i), "optionValue": optArr[i]};
                }
                let data = {
                    title: values.title,
                    imgs: [this.state.imgId],
                    questionType: values.questionType,
                    options: option,
                    questions:[question],
                    diagnosis: values.diagnosis,
                    meaning: values.meaning,
                    feature: values.feature,
                };
                let mes = "";
                let result = "";
                if (this.state.ModalText === '新增技能训练') {
                    result = await reqAddSkill(this.state.cid, data);
                    mes = "添加成功";
                } else {
                    data["id"] = values.id;
                    if(this.state.skill.questions){
                        question["id"]=this.state.skill.questions[0].id;
                    }
                    data["questions"] = [question];
                    result = await reqEditSkill(this.state.cid, data);
                    mes = "修改成功";
                }
                if (result.code === '000000') {
                    let cname = document.getElementsByClassName("getCname")[0].getElementsByClassName("ant-cascader-picker-label")[0].innerText;
                    this.setState({
                        cname:cname
                    });
                    this.getSkillList(this.state.cid, this.state.page, 10);
                    message.success(mes);
                    this.handleCancel();
                } else {
                    message.error(result.data.msg);
                }
            }
        });
    };

    imgUpload = e => {
        document.getElementById("upload").click();
    };

    handleUpload = async (e) => {
        e.persist();
        let file = e.target.files[0];   //选择的图片文件
        let data = new FormData();
        data.append('file', file);

        const result = await reqUpload(data);
        if (result.code === '000000') {
            this.setState({
                imgId: result.data
            });
            message.success("上传成功");
        } else {
            message.error(result.data.msg);
        }

    };

    handleCancel = () => {
        this.setState({
            visible: false,
            deleteVisible: false,
            deleteId: '',
            deleteName: '',
            selectedRowKeys: [],
            imgId: ''
        });
    };

    showAddModal = () => {
        this.setState({
            visible: true,
            ModalText: '新增技能训练',
            skill: {}
        });
    };

    getCategoryList = async (type) => {
        const result = await reqCategory(type);
        if (result.code === '000000') {
            this.setState({
                category: result.data.rows
            })
        } else {
            message.error(result.msg);
        }
    };

    getSkillList = async (cid, page, size) => {
        const result = await reqSkill(cid, page, size);
        if (result.code === '000000') {
            this.setState({
                skillList: result.data.rows,
                page: result.data.page,
                total: result.data.total
            })
        } else {
            message.error(result.data.msg);
        }
    };

    pageClick = async page => {
        this.setState({
            page:page
        });
        this.getSkillList(this.state.cid, page, 10);
        window.scrollTo(0,0);
    };

    itemRender = (current, type, originalElement) => {
        if (type === 'prev') {
            return <a>上一页</a>;
        }
        if (type === 'next') {
            return <a>下一页</a>;
        }
        return originalElement;
    };

    showTotal = (total) => {
        return '共' + total + '条记录/每页' + this.state.size + '条';
    };

    searchList = async() => {
        let cname = document.getElementsByClassName("ant-cascader-picker-label")[0].innerText;
        this.setState({
            cname:cname
        });
        this.getSkillList(this.state.cid,1,10);
    };

    clearSearch = async () => {
        window.location.reload();
    };

    componentDidMount = async () => {
        window.scrollTo(0,0);
        this.getSkillList(3, 1, 10);
        this.getCategoryList("SKILL");
        document.getElementsByClassName("ant-menu-item")[9].click();
    };

    componentWillUnmount() {
        this.setState = (state, callback) => {
            return state;
        }
    }

    render() {

        const {getFieldDecorator} = this.props.form;
        const {total, page, visible,cname, confirmLoading, selectedRowKeys, size, ModalText, deleteId, deleteName, deleteVisible, skillList, category, skill} = this.state;

        const columns = [
            {
                title: '编号',
                dataIndex: 'id',
                key: 'id',
                render: (text, record,index) => (
                    <span>{(this.state.page-1)*this.state.size+index+1}</span>
                ),
            },
            {
                title: '标题',
                dataIndex: 'title',
                key: 'title',
            },
            {
                title: '所属分类',
                dataIndex: 'cname',
                key: 'cname',
                render: (text, record) => (
                    <span>{cname}</span>)
            },
            {
                title: '操作',
                key: 'action',
                render: (text, record) => (
                    <span>
                    <a onClick={this.editSkill.bind(this, record)}>编辑</a>
                    <Divider type="vertical"/>
                    <a onClick={this.showDeleteModal.bind(this, record, '删除')}>删除</a>
                </span>
                ),
            },
        ];

        const rowSelection = {
            selectedRowKeys,
            onChange: (selectedRowKeys, selectedRows) => {
                let name = [];
                for (let i = 0; i < selectedRows.length; i++) {
                    name.push(selectedRows[i].title)
                }
                this.setState({
                    deleteId: selectedRowKeys.toString(),
                    deleteName: name.toString(),
                    selectedRowKeys: selectedRowKeys
                })
            },
            getCheckboxProps: record => ({
                disabled: record.title === 'Disabled User', // Column configuration not to be checked
                name: record.title,
            }),
        };

        const formItemLayout = {
            labelCol: {
                xs: {span: 24},
                sm: {span: 8},
            },
            wrapperCol: {
                xs: {span: 24},
                sm: {span: 16},
            },
        };

        return (
            <Layout>
                <Header>Header</Header>
                <Layout>
                    <LeftAd>LeftAd</LeftAd>
                    <Content>
                        <div className='table_right cas'>
                            <div className='table_search'>
                                <Button className='batch_delete'
                                        onClick={this.showDeleteModal.bind(this, deleteId, '批量删除')}>批量删除</Button>
                                <Button className="add_class" onClick={this.showAddModal}>新增</Button>
                                <Button className='batch_delete clear' onClick={this.clearSearch}>重置</Button>
                                <Button className='batch_delete search' onClick={this.searchList}>检索</Button>
                                <div className='search_box'>
                                    <label>分类</label>
                                    <Cascader allowClear={false} options={category} placeholder="请选择" value={[this.state.pid,this.state.cid]} onChange={this.onChange}
                                              fieldNames={{label: 'name', value: 'id', children: 'subs'}}/>
                                </div>
                            </div>
                            <Table rowSelection={rowSelection} columns={columns} pagination={false}
                                   dataSource={skillList} rowKey={skillList => skillList.id}/>
                            <Pagination total={total} current={page} pageSize={size} onChange={this.pageClick}
                                        itemRender={this.itemRender} showTotal={this.showTotal}/>
                        </div>
                        <Modal title={ModalText} visible={visible} onOk={this.handleSubmit}
                               confirmLoading={confirmLoading} onCancel={this.handleCancel}
                               okText="确认" cancelText="取消" destroyOnClose='true'>
                            <Form {...formItemLayout} className='skillAd'>
                                <Form.Item hidden>
                                    {getFieldDecorator('id', {
                                        initialValue: skill.id,
                                    })(<Input hidden/>)}
                                </Form.Item>
                                <Form.Item label="分类" className='getCname'>
                                    {getFieldDecorator('cid', {
                                        initialValue: [this.state.pid, this.state.cid],
                                        rules: [
                                            {
                                                required: true,
                                                message: '请选择分类!',
                                            },
                                        ],
                                    })(
                                        <Cascader options={category} onChange={this.onChange.bind(this)}
                                                  placeholder="请选择"
                                                  fieldNames={{label: 'name', value: 'id', children: 'subs'}}/>
                                    )}
                                </Form.Item>
                                <Form.Item label="标题">
                                    {getFieldDecorator('title', {
                                        initialValue: skill.title,
                                        rules: [
                                            {
                                                required: true,
                                                message: '请输入标题!',
                                            },
                                        ],
                                    })(<Input autoComplete="off"/>)}
                                </Form.Item>
                                <Form.Item label="类型">
                                    {getFieldDecorator('questionType', {
                                        initialValue: skill.questionType,
                                        rules: [
                                            {
                                                required: true,
                                                message: '请选择类型!',
                                            },
                                        ],
                                    })(
                                        <Radio.Group>
                                            <Radio value={'A'}>A型</Radio>
                                            <Radio value={'X'}>X型</Radio>
                                        </Radio.Group>
                                    )}
                                </Form.Item>
                                <Form.Item label="选项">
                                    {getFieldDecorator('option', {
                                        initialValue: skill.options,
                                        rules: [{required: true, message: '请输入选项!'}],
                                    })(<TextArea rows={4} placeholder={'请输入选项，一行一个选项'}/>)}
                                </Form.Item>
                                <Form.Item label="答案">
                                    {getFieldDecorator('answer', {
                                        initialValue: skill.answer,
                                        rules: [
                                            {
                                                required: true,
                                                message: '请输入答案!',
                                            },
                                        ],
                                    })(<Input placeholder={'如:A（多选请用|分开，如A|C）'} autoComplete="off"/>)}
                                </Form.Item>
                                <Form.Item label="封面">
                                    <Input name="file" accept="image/*" id="upload" type="file"
                                           onChange={this.handleUpload.bind(this)}/>
                                    <button className='upload_div' onClick={this.imgUpload}>上传图片</button>
                                </Form.Item>
                                <Form.Item label="预览图">
                                    {
                                        this.state.imgId && (
                                            <img className='upload'
                                                 src={global.constant.uploadImage + this.state.imgId}/>
                                        )
                                    }
                                </Form.Item>
                                <Form.Item label="诊断">
                                    {getFieldDecorator('diagnosis', {
                                        initialValue: skill.diagnosis,
                                        rules: [
                                            {
                                                required: true,
                                                message: '请输入诊断结果!',
                                            },
                                        ],
                                    })(<Input autoComplete="off"/>)}
                                </Form.Item>
                                <Form.Item label="临床意义">
                                    {getFieldDecorator('meaning', {
                                        initialValue: skill.meaning,
                                        rules: [
                                            {
                                                required: true,
                                                message: '请输入临床意义!',
                                            },
                                        ],
                                    })(<Input autoComplete="off"/>)}
                                </Form.Item>
                                <Form.Item label="特征">
                                    {getFieldDecorator('feature', {
                                        initialValue: skill.feature,
                                        rules: [
                                            {
                                                required: true,
                                                message: '请输入特征!',
                                            },
                                        ],
                                    })(<Input autoComplete="off"/>)}
                                </Form.Item>
                            </Form>
                        </Modal>
                        <Modal
                            title="提示"
                            visible={deleteVisible}
                            okText={"确定"}
                            cancelText={"取消"}
                            onOk={this.deleteSkill.bind(this, deleteId)}
                            onCancel={this.handleCancel}>
                            <div>确定删除吗？</div>
                        </Modal>
                    </Content>
                </Layout>
            </Layout>
        )
    }
}

const WrapSkillAd = Form.create()(SkillAd);
export default WrapSkillAd;